import { createSelector } from 'reselect'

import StringFormat from '../../utils/StringFormat'
import * as companyType from '../../constants/company-types'

export const cartSelector = (state) => state.cart

export const cartIdSelector = createSelector(cartSelector, (cart) => cart.id)

export const cartPaymentTypeSelector = createSelector(
    cartSelector,
    (cart) => cart.paymentType
)

export const cartProductsSelector = createSelector(
    cartSelector,
    (cart) => cart.products
)

export const cartProductsFormatedSelector = createSelector(
    cartProductsSelector,
    (products) =>
        products.map((product) => ({
            id: product.id,
            name: StringFormat.nameProducts(product.id),
            price: product.value,
            quantity: product.qnt
        }))
)

export const cartMaxCardsSelector = createSelector(
    cartSelector,
    (cart) => cart.maxCard
)

export const cartBaselineSelector = (min) =>
    createSelector(cartProductsSelector, (products) =>
        products.reduce((max, product) => Math.max(max, product.qnt), min)
    )

export const cartAvailabilityDateSelector = createSelector(
    cartSelector,
    (cart) => cart.availabilityDate
)

export const cartCompanySelector = createSelector(
    cartSelector,
    (cart) => cart.company
)

export const cartSpokesmanSelector = createSelector(
    cartSelector,
    (cart) => cart.spokesman
)

export const cartIsCorpSelector = createSelector(
    cartSelector,
    (cart) =>
        cart.products.some((product) => +product.qnt > +cart.maxCard) ||
        +cart.code === +companyType.CORP
)

export const cartTotalSelector = createSelector(
    cartSelector,
    (cart) => cart.total ?? 0.0
)

export const cartTotalFeesSelector = createSelector(
    cartSelector,
    (cart) => cart.fees
)

export const cartTotalFeeByTypeSelector = (type) =>
    createSelector(cartTotalFeesSelector, (fees) => {
        let fee = fees.find((f) => f.name === type.name)
        return fee ? fee.value : 0.0
    })

export const cartTermsByProductsSelector = createSelector(
    cartProductsSelector,
    (products) => [
        ...products.map((product) => ({
            id: `accountTerms${StringFormat.cardKind(product.id)}`,
            name: `Contrato de Prestação de Serviços ${StringFormat.renderTerms(product.id)}`,
            checked: false,
            type: product.id
        }))
    ]
)

export const cartDocumentVerificationSelector = createSelector(
    cartSelector,
    (cart) => cart.documentVerification
)

export const cartContractsSelector = createSelector(
    cartSelector,
    (cart) => cart.contracts
)
